import React from "react";
import clsx from 'clsx';
import arrayMove from "array-move";
import Handle from "@gqlapp/base/Handle";

import { SortableContainer as sortableContainer, SortableHandle} from 'react-sortable-hoc';
import { SortableElement as sortableElement } from 'react-sortable-hoc';


const DragHandle = SortableHandle(() => <div className={'handle'}><Handle/></div>);


const SortableContainer =sortableContainer(({ children, className }) => {
	return <ul className={className}>{children}</ul>
})


const SortableItem = sortableElement(({ className, children, ...props }) => {
	return <li className={className} {...props}>{children}</li>
})

function renderData(props: any, columns: any[], entry: any, useDragHandle: any){
	return (columns || []).map(({ dataIndex, render }: any, key: number) =>{
		/*** */
		let data = entry[dataIndex];
		(data && data.render) && (render = data.render);

		if(useDragHandle){ Object.assign(data, { props, handle: <DragHandle /> }) }
		render = render ? render(data, entry, useDragHandle) : data;
		return (<React.Fragment key={key}>{render}</React.Fragment>)
	})
}

function renderBody({ columns, datasource, useDragHandle, props }){
	return (datasource || []).map((entry: any & { tag: any }, key: number) =>{
		if(!entry?.dropDisabled){
			// @ts-ignore
			return (<SortableItem disabled={entry?.disabled} key={key} index={key}>{renderData(props, columns, entry, useDragHandle)}</SortableItem>)
		}else{
			return <li key={key}>{renderData(props, columns, entry, useDragHandle)}</li>
		}
	})
}


export default function Sortable(props: any){
	let { tag, lockAxis, onSortStart: onStart, onSortEnd: onEnd, datasource, columns, className, items, useDragHandle } = props
	let ref = React.createRef();

	/**
	 * set Inline
	 * @param node
	 * @param styles
	 */
	const setInlineStyles = (node: any, styles: any) => {
		Object.keys(styles).forEach((key) => {
			node.style[key] = styles[key];
		});
	};


	function Clone(){
		// @ts-ignore
		return <ul {...{ ref, className: clsx('sortable-hidden', className)}} />
	}

	async function onSortStart(values: any) {
		onStart(values, setInlineStyles);
	}

	async function onSortEnd({ oldIndex, newIndex }) {
		try{
			items = items || datasource;
			items = arrayMove(items, oldIndex, newIndex);
			items = (items || []).map((values: any, weight: number)=>({ ...values, weight }));
			if(typeof onEnd === 'function'){
				await onEnd({ items, oldIndex, newIndex }, setInlineStyles);
			}
		}catch (e) {
			debug(e)
		}
	}

	// @ts-ignore
	return (<><SortableContainer
		{...{ className, useDragHandle,
			props: props?.props || {},
			tag: tag || React.Fragment,
			lockAxis: lockAxis || 'y', onSortStart, onSortEnd,
			helperContainer: () => { return ref.current; }
		}}
	>
		{renderBody({...props, columns, datasource, useDragHandle})}
	</SortableContainer>
		<Clone />
	</>)
}